import { useContext, useEffect, useMemo, useState } from "react";
import {
  GridAlignment,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel,
} from "@mui/x-data-grid-pro";
import NoData from "../../../../../../images/NoData.svg";
import { useNavigate } from "react-router-dom";
import Close from "../../../../../../images/Close.svg";
import { useLazyQuery } from "@apollo/client";
import {
  empType,
  LicenseTypes,
  Operation,
  PageFor,
} from "../../../../../../utils/Enum.types";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {
  DEFAULT_TIME,
  FETCH_MORE_DATA,
  emptyFunc,
  emptyMessage,
} from "../../../../../../utils/constants";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { TableHeaderProps } from "../../../../../../utils/types";
import { ColumnVisibilityFor } from "../../../../../../utils/Enum.Datagrid";
import {
  CustomModal,
  getModifiedScrollHeight,
  toInputStandardDate,
  toIsoDate,
  toStandardDate,
} from "../../../../../../utils/UtilFunctions";
import Navbar from "../../../../../common/layout/Navbar";
import { Title } from "../../../../../../stories/Title/Title";
import Input from "../../../../../../stories/Input/Input";
import { StyledDatagrid } from "../../../../../../styles/DatagridStyles";
import { TABLE_ROW_HEIGHT } from "../../../../../../styles/Variables";
import { Button } from "../../../../../../stories/Button/Button";
import {
  AtsStckRetireItemDetailsEdge,
  AtsStckRetireItemDetailsOrderField,
  GetRetiredItemDetailsResult,
  GetRetiredItemDetailsVar,
} from "../../../DashBoardMapsView/dashboardcomponents/types";
import { GetRetiredItemDetailsList } from "../../../DashBoardMapsView/dashboardcomponents/queries";
import ItemsDetailsAutocomplete from "../../../../../../customComponents/ItemsDetailsAutocomplete";
import { ItemDetailsQueryType } from "../../items/queries/types";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import useLabels from "../../../../../../customHooks/useLabels";
import { TextField } from "@mui/material";
import dayjs from "dayjs";
import Compare from "../../../../../../images/Compare.svg";
import CompaniesAutocomplete from "../../../../customer/companies/CompaniesAutocomplete";
import { payloadTypes } from "../../../../../../context/reducer";
import { AppContext } from "../../../../../../context/context";
import SubsidiarySelect from "../../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../../customComponents/SiteSelect";
import { AddModalStyles } from "../../../../../../styles/CustomModalStyles";
import { getDownloadUrl } from "../../../../../../utils/DownloadFile";
import {
  DownloadDocType,
  ExportRetiredItemDetailsResult,
  ExportRetiredItemDetailsVar,
} from "./queries/types";
import { ExportRetiredItemDetails } from "./queries/queries";
import MessageModal from "../../../../../../customComponents/MessageModal";

interface Props extends NavTypeProps {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  pageType: PageFor;
}

export interface NavTypeProps {
  NavType: LicenseTypes;
}

const JunctionsItemReplacedList = ({
  NavType,
  setModalFlag,
  pageType,
}: Props) => {
  const { RetireItemList } = useAssetTableJson();
  const { dispatch, state } = useContext(AppContext);
  const [message, setMessage] = useState(emptyMessage);

  const { customer_id, itemDetailId } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const {
    itemLabel,
    companyLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
    junctionLabel,
  } = useLabels();

  const navigate = useNavigate();
  const [items, setItems] = useState<AtsStckRetireItemDetailsEdge[]>([]);

  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [selectedItemDeatilsId, setSelectedItemDeatilsId] = useState(0);
  const [importModal, setImportModal] = useState(false);
  const [searchJunction, setSearchJunction] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [getRetiredItemDetails, { data, loading, fetchMore }] = useLazyQuery<
    GetRetiredItemDetailsResult,
    GetRetiredItemDetailsVar
  >(GetRetiredItemDetailsList);

  useEffect(() => {
    if (customer_id)
      getRetiredItemDetails({
        variables: {
          customerID: customer_id,
          companyID: state.companyId,
          subsidiaryID: state.subsidiaryId,
          siteID: state.subSiteId,
          junctionID: state.junctionID,
          itemDetailsID: itemDetailId
            ? Number(itemDetailId)
            : selectedItemDeatilsId
              ? selectedItemDeatilsId
              : 0,
          after: null,
          first: 25,
          startDate: startDate ? toIsoDate(startDate) : undefined,
          endDate: endDate ? toIsoDate(endDate) : undefined,
          orderBy: {
            direction: OrderDirection.DESC,
            field: AtsStckRetireItemDetailsOrderField.CREATED_AT,
          },
          name: searchJunction,
        },
      });
  }, [
    getRetiredItemDetails,
    customer_id,
    itemDetailId,
    selectedItemDeatilsId,
    startDate,
    endDate,
    state.companyId,
    state.subsidiaryId,
    state.subSiteId,
    state.junctionID,
  ]);

  const dynamicHeaders: TableHeaderProps[] = RetireItemList.List.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
    }),
  );
  const columns: GridColDef[] = [...dynamicHeaders];

  const rows1: GridValidRowModel[] = useMemo(() => {
    return items.map(({ node: data }, index) => {
      return {
        id: index + 1,
        retireDate:
          toInputStandardDate(data.retireDate) !== DEFAULT_TIME
            ? toStandardDate(data.retireDate)
            : "-",
        prodSerialNo: data.prodSerialNo,
        prodBatchNo: data.prodBatchNo,
        prodBrand: data.prodBrand,
        prodModel: data.prodModel,
        prodExpiryDate:
          toInputStandardDate(data.prodExpiryDate) !== DEFAULT_TIME
            ? toStandardDate(data.prodExpiryDate)
            : "-",
        prodWarrantyStartDate:
          toInputStandardDate(data.prodWarrantyStartDate) !== DEFAULT_TIME
            ? toStandardDate(data.prodWarrantyStartDate)
            : "-",
        prodWarrantyEndDate:
          toInputStandardDate(data.prodWarrantyEndDate) !== DEFAULT_TIME
            ? toStandardDate(data.prodWarrantyEndDate)
            : "-",
        prodInstallationEndDate:
          toInputStandardDate(data.prodInstallationEndDate) !== DEFAULT_TIME
            ? toStandardDate(data.prodInstallationEndDate)
            : "-",
        siteLocation: `${data.prodLatitude}, ${data.prodLongitude}`,
        subsidiary: data.subsidiaryDetails.name,
        company: data.company.name,
        item: data.item.desc,
        site: data.site.name,
        junction: data.junction.name,
        remark: data.remark ? data.remark : "-",
      };
    });
  }, [items]);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.ITEMS_LIST);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel,
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.ITEMS_LIST,
      JSON.stringify(newModel),
    );
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetRetiredItemDetails.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (sub) => sub.node.id === newCompany.node.id,
          );
          if (filteredStudent) {
            return {
              ...newCompany,

              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(data.GetRetiredItemDetails.pageInfo.endCursor);
    } // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller",
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetRetiredItemDetails.edges;
              const pageInfo = fetchMoreResult.GetRetiredItemDetails.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck =
                prevResult.GetRetiredItemDetails.edges.filter(
                  ({ node: { id } }) =>
                    newEdges.findIndex(
                      ({ node: { id: newId } }) => newId === id,
                    ) !== -1,
                );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetRetiredItemDetails: {
                  edges: [...items, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetRetiredItemDetails.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable) scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, [items, data]);

  const [exportRetiredItemDetails] = useLazyQuery<
    ExportRetiredItemDetailsResult,
    ExportRetiredItemDetailsVar
  >(ExportRetiredItemDetails);

  const handleExport = async () => {
    try {
      if (customer_id) {
        const { data, errors } = await exportRetiredItemDetails({
          variables: {
            customerID: customer_id,
            companyID: state.companyId,
            subsidiaryID: state.subsidiaryId,
            siteID: state.subSiteId,
            junctionID: state.junctionID ? state.junctionID : undefined,
            itemDetailsID: state.itemDetailsId,
            startDate: startDate ? toIsoDate(startDate) : undefined,
            endDate: endDate ? toIsoDate(endDate) : undefined,
            format: DownloadDocType.EXCEL,
          },
        });
        if (data && data.ExportRetiredItemDetails) {
          const res = await getDownloadUrl(data.ExportRetiredItemDetails, true);
          if (res) {
            setMessage({
              flag: true,
              message: "Downloading...",
              operation: Operation.CREATE,
            });
          }
        } else {
          setMessage({
            flag: true,
            message: "Failed downloading file",
            operation: Operation.NONE,
          });
        }
        if (errors && errors.length > 0) {
          setMessage({
            flag: true,
            message: errors[0].message,
            operation: Operation.NONE,
          });
        }
      }
    } catch (err) {
      setMessage({
        flag: true,
        message: (err as Error).message,
        operation: Operation.NONE,
      });
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      setModalFlag(false);
    }
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };

  return (
    <>
      {pageType === PageFor.GENERAL && <Navbar NavType={NavType} />}
      {pageType === PageFor.GENERAL ? (
        <Title>{junctionLabel} Component Report</Title>
      ) : (
        <div className="item-ob__title">
          <Title>{junctionLabel} Component Report</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
      )}

      <div
        className={`item-ob${pageType === PageFor.GENERAL ? "" : "__modal"}`}
      >
        <div className="item-ob__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => {
                setSearchJunction(e.target.value);
              }}
            />
          </div>

          <div className="col">
            <CompaniesAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_COMPANY_ID,
                    payload: {
                      companyId: newValue.node.id,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_COMPANY_ID,
                    payload: {
                      companyId: 0,
                    },
                  });
                  dispatch({
                    type: payloadTypes.SET_SUB_ID,
                    payload: {
                      subsidiaryId: 0,
                    },
                  });
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: 0,
                    },
                  });
                }
              }}
              onKeyDown={emptyFunc}
              value={state.companyId ? state.companyId : 0}
              label={companyLabel}
            />
          </div>

          <div className="col">
            <SubsidiarySelect
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_SUB_ID,
                    payload: {
                      subsidiaryId: newValue.node.id,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_SUB_ID,
                    payload: {
                      subsidiaryId: 0,
                    },
                  });
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: 0,
                    },
                  });
                }
              }}
              onKeyDown={emptyFunc}
              companyID={state.companyId ? state.companyId : 0}
              value={state.subsidiaryId ? state.subsidiaryId : 0}
              label={subsidiaryLabel}
            />
          </div>

          <div className="col">
            <SiteSelect
              onChange={(newValue) => {
                if (newValue) {
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: newValue.value,
                    },
                  });
                } else {
                  dispatch({
                    type: payloadTypes.SET_SUB_SITE_ID,
                    payload: {
                      subSiteId: 0,
                    },
                  });
                }
              }}
              companyId={state.companyId ? state.companyId : 0}
              subsidiaryId={state.subsidiaryId ? state.subsidiaryId : 0}
              onKeyDown={emptyFunc}
              value={state.subSiteId ? state.subSiteId : 0}
              label={subsidiarySiteLabel}
            />
          </div>

          <div className="col-2">
            <ItemsDetailsAutocomplete
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedItemDeatilsId(newValue.value);
                } else {
                  setSelectedItemDeatilsId(0);
                }
              }}
              onKeyDown={emptyFunc}
              value={selectedItemDeatilsId}
              input={{
                query_type: ItemDetailsQueryType.ALL,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckUomID: 0,
                stckSubCategoryID: 0,
                itemID: 0,
                ldgrID: 0,
                poleNum: 0,
                empID: user_details.id!,
              }}
              queryInput={{
                companyID: 0,
                customerID: customer_id!,
                junctionID: 0,
                siteID: 0,
                subsidiaryID: 0,
              }}
              label={`${itemLabel} Details`}
            />
          </div>
          <div className="col">
            <div className="tkt-raised-list__select--flex">
              <TextField
                label="From date"
                className="tkt-raised-list__select--textfield"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                type="date"
                onChange={(e) => {
                  if (dayjs(e.target.value).isAfter(dayjs(endDate))) {
                    return;
                  }

                  setStartDate(e.target.value);
                }}
                value={startDate}
              />
              <img src={Compare} alt="" />

              <TextField
                label="To date"
                className="tkt-raised-list__select--textfield"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                type="date"
                onChange={(e) => {
                  if (dayjs(e.target.value).isBefore(dayjs(startDate))) {
                    return;
                  }
                  setEndDate(e.target.value);
                }}
                value={endDate}
              />
            </div>
          </div>
        </div>
        <div className="item-ob__tableblock">
          {items.length ? (
            <StyledDatagrid
              columns={columns}
              rows={rows1}
              rowHeight={TABLE_ROW_HEIGHT}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={handleColumnVisibilityChange}
              initialState={{
                columns: {
                  columnVisibilityModel: columnVisibilityModel,
                },
              }}
              disableRowSelectionOnClick
              hideFooter
            />
          ) : (
            <>
              <img src={NoData} alt="" className="nodata-image" />
            </>
          )}
        </div>
        <div className="row">
          <div className="col-2">
            {pageType === PageFor.GENERAL &&
            (state.empSubType === empType.SYS_ADMIN ||
              state.empSubType === empType.TECHNICIAN ||
              state.empSubType === empType.VENDOR_MANAGER) ? (
              <Button mode="excel" type="button" onClick={() => handleExport()}>
                Export
              </Button>
            ) : null}
            {pageType === PageFor.GENERAL ? (
              <Button mode="back" onClick={() => navigate(-1)} />
            ) : (
              <Button mode="cancel" onClick={() => setModalFlag(false)} />
            )}
          </div>

          <div className="col"></div>
          <div className="col-2 flex-end">
            <div className="overall-total-count">
              Total Count <b>{data?.GetRetiredItemDetails.totalCount}</b>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        isOpen={importModal}
        onRequestClose={() => setImportModal(!importModal)}
        contentComponent={<></>}
        style={AddModalStyles}
      />

      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleClose}
        operation={message.operation!}
      />
    </>
  );
};

export default JunctionsItemReplacedList;
